import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post } from './agent';

const timeAdmin =
  (workspacesUrl) =>
  (id = '') => {
    const url = _([workspacesUrl, 'time-admin', id]).compact().join('/');

    return {
      getApprovals: (query = {}) =>
        get(url.concat('/approvals', new QueryString(query, { multi: true }).toString(true))),
      getPendingApprovalsCount: (query = {}) =>
        get(url.concat('/pending-approvals-count', new QueryString(query).toString(true))),
      batchUpdateStatus: (body) => post(url.concat('/approvals/batch'), body),
      setStatus: (body) => post(url.concat('/approvals/set-status'), body),
      getAuditing: (query = {}) => get(url.concat('/auditing', new QueryString(query, { multi: true }).toString(true))),
      exportAuditing: (query = {}, headers = {}) =>
        get(url.concat('/auditing/export').concat(new QueryString(query, { multi: true }).toString(true)), headers),
      create: (body) => post(url, body),
      update: (body) => patch(url, body),
      delete: () => del(url),
      bulkDelete: (ids) => post(url.concat('/bulk-delete'), { ids }),
      bulkSetApprovalStatus: (ids, body) => post(url.concat('/bulk-set-approval-status'), { ids, ...body }),
    };
  };

export default timeAdmin;
